<template>

  <div class="driver-top-box">
    <div class="driver-left">
      <div>
        <img class="driver-top-img" style="border-radius: 9px" :src="getFileAccessHttpUrl(model.logo || 'https://oss.dimoclub.com/static/driver/default_logo.png')"/>
      </div>
      <div :style="{lineHeight:'48px'}">
        <h4 style="font-size: 16px;margin-bottom: 0;display: inline-block;">{{model.platformName}}</h4>
      </div>
    </div>
    <div class="tab-list">
      <a-table
        :columns="columns"
        :dataSource="[model]"
        :pagination="false"
      >
        <template slot="carLabel" slot-scope="text">
          <span v-if="text" style="color: #FF0000;cursor: pointer" @click="editLabel">{{text.split(",").length}}</span>
          <span v-else @click="editLabel" style="color: #2A82E4;cursor: pointer">添加标签</span>
        </template>
        <template slot="driverName" slot-scope="text,record">
            <span :title="record.driver.driverName"  style="cursor: pointer" :style="{
              color:record.driver.driverLabel?'#ff0000':'#2A82E4'
            }" @click="viewDriverInfo(record.driverId)">{{record.driver.driverName}}</span>

        </template>
        <template slot="other" slot-scope="text">
          <span style="color: #2A82E4;cursor: pointer" @click="viewInfo">点击查看</span>
        </template>
      </a-table>
    </div>
    <driver-new-info ref="driverModel" @ok="submitCallback"></driver-new-info>
    <platform-info ref="platformModel"  @update="submitCallback" :model="model"></platform-info>
  </div>
</template>

<script>

import {getFileAccessHttpUrl} from '@/api/manage'
import PlatformInfo from "@comp/dm5/driver/PlatformInfo.vue";
export default {
  name: 'PlatformInfoTop',
  components: {
    PlatformInfo
  ,
  DriverNewInfo: () => import('@views/dm5/DriverModalInfo'),
  },
  props:{
    model:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      getFileAccessHttpUrl:getFileAccessHttpUrl,
      columns:[
        {
          title:'客户',
          align:"left",
          dataIndex: 'id',
          scopedSlots: { customRender: 'driverName' }
        },
        {
          title:'更多',
          align:"left",
          width:140,
          dataIndex: 'id',
          scopedSlots: { customRender: 'other' }
        }
      ]
    }
  },methods:{
    submitCallback(){
      this.$emit("update",1);
    },viewDriverInfo(driverId){
      this.$refs.driverModel.disableSubmit = false;
      this.$refs.driverModel.showInfo(null,driverId,{s:'基本信息',leftTab:1,b:''});
    },viewInfo(){
      this.$refs.platformModel.show();
    }
  }
}
</script>
<style lang="less" scoped>
.driver-top-box{
  display: flex;
  gap: 24px;
  margin-top: 10px;
}
.driver-left{
  min-width: 240px;
  height: 72px;
  background: linear-gradient(180deg, #DFE9F3 0%, #FFFFFF 100%);
  border-radius: 6px;
  display: flex;
  gap: 10px;
  padding: 15px 22px;
  box-shadow: 0px 6px 12px -3px rgba(230, 237, 245, 1);
}
.driver-left img{
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.tab-list{
  flex: 1;
}
.cure-info{
  display: flex;
  gap: 6px;
  justify-content: center;
}
.cure-info img{
  width: 20px;
  height: 20px;
  border-radius: 6px;
}
/deep/ .tab-list .ant-table-tbody{
  background: #fff;
}
/deep/ .tab-list .ant-table-tbody > tr > td,
/deep/ .tab-list  .ant-table-thead > tr > th{
  padding: 7px 8px !important;
}
</style>